<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="addRequiredProjectItemsModal" ref="modalEle" tabindex="-1" role="dialog"
            aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-full-width" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Dodaj pozycje do zapotrzebowania projektowego</h5>
                        <Link :href="route('articles.index')">
                        </Link>
                        <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="container-fluid">
                            <template v-if="!project || !team">
                                <h4 class="text-warning">Najpierw wybierz projekt oraz zespół</h4>
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                                    <i class="bi bi-x-square me-2"></i>Zamknij
                                </button>
                            </template>

                            <template v-else>
                                <div v-if="selectedArticles.length > 0" class="table-responsive"
                                    style="border-bottom:1px solid #ddd; padding-bottom:20px">
                                    <h5>Lista wybranych artykułów</h5>
                                    <table class="table table-striped">
                                        <thead>
                                            <tr>
                                                <th></th>
                                                <th>#</th>
                                                <th>Nr Katalogowy</th>
                                                <th>Model</th>
                                                <th>Producent</th>
                                                <th>J.m.</th>
                                                <th>Nazwa/Opis</th>
                                                <th>Stan magazynowy</th>
                                                <th>Rezerwacja</th>
                                                <th>Ilość maszyn<br>(Ilość do zamówienia)</th>
                                                <th>Ilość wymagana</th>
                                                <th>Dostawcy</th>
                                                <th>Uwagi</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="article in selectedArticles" :key="article.id">
                                                <td>
                                                    <button @click="removeFromSelectedArticles(article.id)"
                                                        class="btn btn-outline-danger btn-xs">
                                                        Usuń
                                                    </button>
                                                </td>
                                                <td>{{ article.id }}</td>
                                                <td>{{ article.catalog_number }}</td>
                                                <td>{{ article.model }}</td>
                                                <td>{{ article.producer?.name }}</td>
                                                <td>{{ article.article_unit.name }}</td>
                                                <td>{{ article.description }}</td>
                                                <td>
                                                    {{ article.available_items?.quantity ?? 0 }}
                                                    <span v-if="reservingArticles[article.id]?.currently_reserved">
                                                        (w rezerwacji: {{
                                                            Math.abs(reservingArticles[article.id].currently_reserved) }})
                                                    </span>
                                                </td>

                                                <!-- Rezerwacja -->
                                                <td class="cell-editable position-relative">
                                                    <i v-if="article.reserved > (article.quantity_required * this.liczba_maszyn)"
                                                        class="position-absolute bi bi-exclamation-triangle-fill text-warning me-1"
                                                        data-bs-toggle="tooltip" data-bs-placement="top"
                                                        data-bs-html="true"
                                                        style="right: 10px; top: 50%; transform: translateY(-50%);"
                                                        title="Rezerwacja jest większa niż ilość wymagana.">
                                                    </i>

                                                    <input type="number"
                                                        :min="isIntegerUnit(article.article_unit?.name) ? 0 : 0.01"
                                                        :step="isIntegerUnit(article.article_unit?.name) ? 1 : 0.01"
                                                        :max="Math.max(article.available_items?.quantity ?? 0, 0)"
                                                        v-model.number="article.reserved"
                                                        @input="onReservedInput(article)"
                                                        @keydown="blockNonNumeric($event, article.article_unit?.name)"
                                                        class="form-control form-control-sm" :class="{
                                                            'is-invalid': reservingArticles[article.id]?.ok === false,
                                                            'border-warning border-2': article.reserved > (article.quantity_required * this.liczba_maszyn)
                                                        }" />
                                                </td>

                                                <!-- Ilość do zamówienia -->
                                                <td>
                                                    <template v-if="quantityToOrderIsLoading">
                                                        <div class="text-center my-3">
                                                            <div class="spinner-border spinner-border-reverse align-self-center loader-xs text-secondary"
                                                                style="height: 20px; width: 20px;">
                                                                Ładowanie...
                                                            </div>
                                                        </div>
                                                    </template>
                                                    {{ quantityToOrderMap[article.id] }}
                                                    ({{ Math.max(((article.quantity_required * this.liczba_maszyn) || 0)
                                                    - (article.reserved || 0), 0) }})
                                                </td>

                                                <!-- Ilość wymagana -->
                                                <td class="cell-editable">
                                                    <input type="number"
                                                        :min="isIntegerUnit(article.article_unit?.name) ? 1 : null"
                                                        :step="isIntegerUnit(article.article_unit?.name) ? 1 : 0.01"
                                                        v-model="article.quantity_required"
                                                        @input="onQuantityInput(article)"
                                                        @keydown="blockNonNumeric($event, article.article_unit?.name)"
                                                        class="form-control form-control-sm" />
                                                </td>

                                                <!-- Dostawcy -->
                                                <td class="cell-editable">
                                                    <Vueform>
                                                        <TagsElement id="suppliers_short_names"
                                                            name="suppliers_short_names" autocomplete="off"
                                                            :search="true" :native="false" :items="suppliers"
                                                            labelProp="short_name" valueProp="short_name"
                                                            :default="article.suppliers_short_names_array"
                                                            @change="changeSuppliersHandler(article, $event)">
                                                            <template
                                                                v-slot:tag="{ option, handleTagRemove, disabled }">
                                                                <div :class="{
                                                                    'original-tag': isOriginalSupplier(option, article),
                                                                    'new-tag': !isOriginalSupplier(option, article)
                                                                }" class="tag-item">
                                                                    {{ option.short_name }}
                                                                    <span v-if="!disabled"
                                                                        class="multiselect-tag-remove"
                                                                        @mousedown.prevent="handleTagRemove(option, $event)">
                                                                        <span
                                                                            class="multiselect-tag-remove-icon ps-1">x</span>
                                                                    </span>
                                                                </div>
                                                            </template>
                                                        </TagsElement>
                                                    </Vueform>
                                                </td>

                                                <td class="cell-editable">
                                                    <input type="text" v-model="article.comments"
                                                        class="form-control form-control-sm" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>

                                    <button type="button" class="btn btn-primary" @click="saveSelectedPositions"
                                        :disabled="isSubmiting || !allArticlesReservable">
                                        Dodaj wybrane pozycje
                                    </button>
                                </div>

                                <h5 class="pt-4 pb-2">Lista dostępnych artykułów</h5>
                                <ejs-grid ref="addRequiredProjectItemsGrid" id="addRequiredProjectItemsGrid"
                                    height="500px" :dataSource="articlesDataManager" :allowTextWrap='false'
                                    :allowExcelExport='false' :allowPaging="true" :allowSorting='true'
                                    :allowFiltering='true' :allowReordering='true' :allowResizing='true'
                                    :showColumnChooser='true' :allowSelection='true' :enablePersistence='true'
                                    :pageSettings="pageSettings" :editSettings="editSettings"
                                    :filterSettings="filterOptions" :toolbar="toolbar"
                                    :selectionSettings="selectionOptions" :actionBegin="actionBegin"
                                    :actionComplete="actionComplete" :dataBound="dataBoundHandler"
                                    :toolbarClick="clickToolbarHandler">
                                    <e-columns>
                                        <e-column headerText="Dodaj" width="80" :template="'addTemplate'"
                                            textAlign="Center"></e-column>
                                        <e-column field="id" headerText="ID" width="100" :isPrimaryKey="true"
                                            :visible="true" :allowEditing="false" />
                                        <e-column field="photos" headerText="Zdjęcia" width="150"
                                            :template="'imageTemplate'" :allowEditing="false" :allowFiltering="false"
                                            :allowSorting="false"></e-column>
                                        <e-column field="catalog_number" headerText="Nr katalogowy" width="150"
                                            :filter="filterDefault" :allowEditing="false" />
                                        <e-column field="model" headerText="Model" width="150" :filter="filterDefault"
                                            :allowEditing="false" />
                                        <e-column field="article_unit.id" headerText="J.m." width="150"
                                            editType="dropdownedit" :dataSource="units" foreignKeyValue='name'
                                            foreignKeyField='id' :filter='filterUnits' :allowEditing="false" />
                                        <e-column field="description" headerText="Nazwa/Opis" :defaultValue="null"
                                            width="200" :filter="filterDefault" :allowEditing="false" />
                                        <e-column field="link" headerText="Link" :defaultValue="null"
                                            :filter="filterDefault" :template="'linkTemplate'" :allowEditing="false" />
                                        <e-column field="available_items.quantity" headerText="Ilość/Stany magazynowe"
                                            width="150" format="N2" :filter="filterNumeric" type="string"
                                            :allowEditing="false" />
                                        <e-column field="suppliers_short_names" headerText="Dostawcy" editType="string"
                                            :allowEditing="false" :dataSource="suppliers" :filter="filterSuppliers" />
                                        <e-column field="producer_name" headerText="Producent" editType="string"
                                            :allowEditing="false" :dataSource="producers" :filter="filterDefault" />
                                    </e-columns>

                                    <template v-slot:addTemplate="{ data }">
                                        <template v-if="!isArticleSelected(data.id)">
                                            <button @click="addToNewItems(data)"
                                                class="btn btn-xs btn-outline-primary">Dodaj
                                            </button>
                                        </template>
                                        <template v-else><span class="text-success">Wybrano</span></template>
                                    </template>

                                    <template v-slot:linkTemplate="{ data }">
                                        <a class="link link-primary" target="_blank" rel="noopener noreferrer"
                                            :href=data.link>{{
                                                data.link
                                            }}</a>
                                    </template>

                                    <template v-slot:imageTemplate="{ data }">
                                        <div v-if="data.photos && data.photos.length > 0">
                                            <img :src="`/${data.photos[0].photo_path}`" alt="Zdjęcie"
                                                style="max-height: 100px; max-width: 150px" />
                                        </div>
                                    </template>

                                </ejs-grid>
                            </template>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                            <i class="bi bi-x-square me-2"></i>Zamknij
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <AddArticleModal ref="addArticleModalRef" @save-article="createArticleFromModal" @added-success="successMsg"
        @added-error="errorMsg" :units="units" :categories="categories" :producers="copyproducers"
        :suppliers="suppliers" :currencys="currencys" />
</template>

<script>
import { Modal } from "bootstrap";
import {
    ColumnChooser,
    ColumnDirective,
    ColumnsDirective,
    ContextMenu,
    Edit,
    ExcelExport,
    Filter, ForeignKey,
    GridComponent,
    Page,
    Reorder,
    Resize,
    Sort,
    Toolbar,
    RowDD,
    VirtualScroll
} from '@syncfusion/ej2-vue-grids';
import { createElement } from "@syncfusion/ej2-base";
import { DataManager, Predicate, Query, WebMethodAdaptor } from '@syncfusion/ej2-data';
import { DropDownList } from "@syncfusion/ej2-dropdowns";
import { router, usePage } from "@inertiajs/vue3";
import { MultiSelect } from "@syncfusion/ej2-vue-dropdowns";
import { ref } from "vue";
import AddArticleModal from '@/Pages/Warehouses/Articles/AddArticleModal.vue';
import { usePermission } from "@/composables/resources/js/composables/permissions.js";

const { hasPermission } = usePermission();

let dropInstanceFilterUnits, delivererElem = ref(null), multiSelectObj = ref(null);

export default {
    components: {
        AddArticleModal,
        'ejs-grid': GridComponent,
        'e-columns': ColumnsDirective,
		hasPermission,
        'e-column': ColumnDirective
    },

    provide: {
        grid: [Page, Edit, Toolbar, ContextMenu, Sort, Filter, Reorder, Resize, ColumnChooser, ExcelExport, ForeignKey, RowDD, VirtualScroll]
    },

    props: {
        project: Number | String,
        team: Boolean | String,
        units: Object,
        suppliers: Object,
        currencys: Object,
        producers: Object,
        categories: Object,
        articlesToClone: { type: Array, default: () => [] },
        liczba_maszyn: {
            type: Number,
            default: 1
        },
    },

    computed: {
        allArticlesReservable() {
            const reservations = Object.values(this.reservingArticles);
            const canReserve = reservations.length === 0 || reservations.every(r => r.ok === true);

            return canReserve;
        },
        toolbar() {
            return this.getToolbar();
        }
    },

    watch: {
        articlesToClone: {
            immediate: true,
            deep: true,
            handler(val) {
                if (val && val.length) this.addManyToSelected(val);
            }
        }

    },

    data() {

        return {
            copyproducers: this.producers,
            hasSearch: false,
			hasPermission,
            articlesDataManager: [],
            modalObj: null,
            selectedArticles: [],
            isSubmiting: false,
            reservingArticles: {},
            quantityToOrderIsLoading: false,
            quantityToOrderMap: {},
            pageSettings: { pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200, 500, 1000] },
            filterOptions: { type: "Menu", operator: 'contains' },
            filterDefault: { operator: 'contains', params: { minLength: 2 } },
            filterNumeric: { operator: 'equal' },
            editSettings: this.getEditSettings(),

            selectionOptions: { checkboxOnly: true, persistSelection: true },
            filterUnits: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.units,
                            fields: { text: 'name', value: 'id' },
                            placeholder: 'Szukaj jednostki',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },

            filterSuppliers: {
                operator: 'contains',
                ui: {
                    create: (args) => {
                        let flValInput = createElement('input', { className: 'flm-input' });
                        args.target.appendChild(flValInput);
                        dropInstanceFilterUnits = new DropDownList({
                            dataSource: this.suppliers,
                            fields: { text: 'short_name', value: 'short_name' },
                            placeholder: 'Szukaj dostawców',
                            popupHeight: '200px',
                            allowFiltering: true
                        });
                        dropInstanceFilterUnits.appendTo(flValInput);
                    },
                    write: (args) => {
                        dropInstanceFilterUnits.text = args.filteredValue || '';
                    },
                    read: (args) => {
                        args.fltrObj.filterByColumn(args.column.field, args.operator, dropInstanceFilterUnits.text);
                    }
                }
            },

            suppliersParams: {
                create: () => {
                    this.delivererElem = document.createElement("input");
                    return this.delivererElem;
                },
                read: () => {
                    return this.multiSelectObj ? this.multiSelectObj.value.join(",") : "";
                },
                destroy: () => {
                    if (this.multiSelectObj) {
                        this.multiSelectObj.destroy();
                        this.multiSelectObj = null;
                    }
                },
                write: (args) => {
                    const values = args.rowData.suppliers_short_names || ""; // Zabezpieczenie przed null
                    const selectedValues = values ? values.split(",") : [];

                    this.multiSelectObj = new MultiSelect({
                        value: selectedValues,
                        dataSource: this.suppliers,
                        fields: { text: "short_name", value: "short_name" },
                        placeholder: "Wybierz dostawców",
                        mode: "Box",
                        allowFiltering: true,
                        popupHeight: "200px",
                        closePopupOnSelect: false,
                    });

                    this.multiSelectObj.appendTo(this.delivererElem);
                },
            },
        }
    },
    mounted() {
        this.modalObj = new Modal(this.$refs.modalEle);

        this.$refs.modalEle.addEventListener('hide.bs.modal', async (event) => {
            if (this.selectedArticles.length === 0) {
                return;
            }

            event.preventDefault();

            const res = await Toast.fire({
                toast: false,
                icon: 'question',
                title: 'Zamknąć modal?',
                html: 'Masz wybrane artykuły. Czy na pewno chcesz zamknąć modal i usunąć wybrane pozycje?',
                showDenyButton: true,
                position: 'center',
                timer: false,
                showConfirmButton: true,
                confirmButtonText: 'Tak',
                denyButtonText: 'Nie'
            });

            if (res.isConfirmed) {
                this.selectedArticles = [];
                this.reservingArticles = {};

                this.modalObj.hide();
            }
        });

        this.$refs.modalEle.addEventListener('hidden.bs.modal', () => {
            this.$emit('clear-selection');
            this.clearSelectedArticles();
            this.$refs.modalEle?.classList.remove('modal-parent-inactive');
        });

        const articleModal = document.getElementById('addArticleModal');

        articleModal?.addEventListener('shown.bs.modal', () => {
            this.$refs.modalEle?.classList.add('modal-parent-inactive');
        });

        articleModal?.addEventListener('hidden.bs.modal', () => {
            this.$refs.modalEle?.classList.remove('modal-parent-inactive');
        });
    },

    beforeMount() {
        this.getArticles();
    },

    methods: {
        dataBoundHandler() {
            const grid = this.$refs.addRequiredProjectItemsGrid.ej2Instances;

            const hasSearchNow = !!grid.searchSettings.key;

            if (this.hasSearch !== hasSearchNow) {
                this.hasSearch = hasSearchNow;
                this.toolbar = this.getToolbar();
            }
        },

        clearSelectedArticles() {
            this.selectedArticles = [];
            this.reservingArticles = {};
            this.quantityToOrderMap = {};

            // opcjonalnie czyść zaznaczenia w Syncfusion Grid
            const grid = this.$refs.addRequiredProjectItemsGrid?.ej2Instances;
            if (grid) {
                grid.clearSelection();
            }
        },

        async articleAlreadyExist(result) {

            const articles = result.articles || [];

            if (!articles.length) {
                return false;
            }

            let html = `
    <table class="table table-bordered">
      <thead>
        <tr>
          <th>Nr Kat.</th>
          <th>Model</th>
          <th>Opis</th>
          <th>Producent</th>
        </tr>
      </thead>
      <tbody>
  `;

            articles.forEach(article => {
                html += `
      <tr>
        <td>${article.catalog_number || ''}</td>
        <td>${article.model || ''}</td>
        <td>${article.description || ''}</td>
        <td>${article.producer?.name || 'Brak producenta'}</td>
      </tr>
    `;
            });

            html += `
      </tbody>
    </table>
  `;

            const sameProducer = result.same_producer_exists;

            await Toast.fire({
                position: 'center',
                toast: false,
                icon: sameProducer ? 'error' : 'warning',

                title: sameProducer
                    ? 'Taki artykuł już istnieje'
                    : 'Istnieją artykuły z tym numerem i modelem',

                html: sameProducer
                    ? `
          ${html}

          <div style="
            margin-top:10px;
            color:red;
            font-weight:bold;
          ">
            Artykuł z tym numerem katalogowym,
            modelem i producentem już istnieje.
            Dodanie zostało zablokowane.
          </div>
        `
                    : html,

                timer: false,
                showCancelButton: false,
                showCloseButton: true,
                showConfirmButton: true,
                confirmButtonText: 'Ok',
            });

            return sameProducer;
        },
        successMsg(resp) {
            Toast.fire({
                position: 'top-end',
                toast: true,
                icon: 'success',
                title: 'Sukces!',
                html: resp,
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                timer: 2500,
                timerProgressBar: true,
                showConfirmButton: false,
                showCloseButton: true
            });
        },

        errorMsg(resp) {
            Toast.fire({
                position: 'top-end',
                toast: true,
                icon: 'warning',
                title: 'Błąd!',
                html: resp,
                showClass: { popup: 'animate__animated animate__fadeInDown' },
                hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                timer: 2500,
                timerProgressBar: true,
                showConfirmButton: false,
                showCloseButton: true
            });
        },
        async checkCatalogNumber(catalogNumber, model, producerId, producerName) {
            try {
                const response = await axios.post(
                    route('article.check-catalog-number-if-exists'),
                    {
                        catalog_number: catalogNumber,
                        model: model,
                        producer_id: producerId || null,
                        producer_name: producerName || '',
                    }
                );

                return response.data;

            } catch (error) {
                console.error(
                    'Błąd podczas sprawdzania numeru katalogowego:',
                    error
                );

                return {
                    same_producer_exists: false,
                    articles: []
                };
            }
        },
        cloneToModal(sourceRow) {
            const clone = JSON.parse(JSON.stringify(sourceRow));
            clone.id = null;
            this.$nextTick(() => {
                const modal = this.$refs.addArticleModalRef;
                modal.resetForm();
                modal.setDataFromClone(clone);
                modal.show();
            });
        },
        async createArticleFromModal(payload) {

            const result = await this.checkCatalogNumber(
                payload.catalog_number,
                payload.model,
                payload.producer_id,
                payload.producer_name
            );

            if (result.articles?.length > 0) {

                const blocked = await this.articleAlreadyExist(result);

                if (blocked) {
                    this.isAddingNew = false;
                    return;
                }
            }

            this.$inertia.post(route('articles.saveChanges'), {
                added: [payload],
            }, {
                only: [
                    'errors',
                    'flash',
                    'newRecords',
                    'articles',
                    'producers'
                ],
                preserveState: true,

                onSuccess: (page) => {

                    const flashError = page.props.flash?.error;

                    if (flashError) {
                        Toast.fire({
                            position: 'top-end',
                            toast: false,
                            icon: 'warning',
                            title: 'Błąd zapisu',
                            html: flashError,
                            showConfirmButton: true
                        });

                        const grid = this.$refs.addRequiredProjectItemsGrid?.ej2Instances;

                        if (grid) {
                            grid.refresh();
                        }

                        this.isAddingNew = false;
                        return;
                    }

                    this.copyproducers = page.props.producers;
                    this.copycurrencys = page.props.currencys;

                    this.$refs.addRequiredProjectItemsGrid.ej2Instances.refresh();

                    this.successMsg('Dane zostały zapisane!');
                    this.$makeClean();

                    this.$refs.addArticleModalRef.hide();
                    this.$refs.addArticleModalRef.resetForm();
                },

                onError: (errors) => {
                    console.error(
                        'Błąd podczas zapisywania danych:',
                        errors
                    );

                    this.errorMsg('Błąd podczas zapisywania danych.');
                    this.isAddingNew = false;
                }
            });
        },

        // Sprawdza czy jednostka wymaga liczby całkowitej
        isIntegerUnit(unitName) {
            return unitName && ['szt', 'szt.', 'kpl'].includes(unitName.toLowerCase());
        },

        // Blokuje niecyfrowe znaki dla jednostek całkowitych
        blockNonNumeric(event, unitName) {
            const allowedKeys = [
                'Backspace', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Delete', 'Tab'
            ];

            if (allowedKeys.includes(event.key)) return;

            if (this.isIntegerUnit(unitName)) {
                if (!/^\d$/.test(event.key)) event.preventDefault();
            } else {
                if (!/^[\d.,]$/.test(event.key)) event.preventDefault();
            }
        },

        // Walidacja i zaokrąglanie ilości wymaganej
        onQuantityInput(article) {
            if (article.quantity_required === null || article.quantity_required === '') return;

            if (this.isIntegerUnit(article.article_unit?.name)) {
                article.quantity_required = Math.max(1, Math.floor(article.quantity_required || 1));
            } else {
                let val = article.quantity_required;
                if (typeof val === 'string') val = val.replace(',', '.');
                const parsed = parseFloat(val);
                article.quantity_required = isNaN(parsed) ? null : parsed;
            }

            // Przeliczanie rezerwacji tylko jeśli jest wartość
            if (article.quantity_required !== null) {
                const availableInStock = (article.available_items?.quantity || 0) - Math.abs(this.reservingArticles[article.id]?.currently_reserved || 0);
                article.reserved = Math.min((article.quantity_required * this.liczba_maszyn), availableInStock > 0 ? availableInStock : 0);
                article.quantity_to_order = Math.max(0, (article.quantity_required * this.liczba_maszyn) - article.reserved);
            }
        },

        // Walidacja i zaokrąglanie ilości w rezerwacji
        onReservedInput(article) {
            if (this.isIntegerUnit(article.article_unit?.name)) {
                article.reserved = Math.max(0, Math.floor(article.reserved || 0));
            } else {
                let val = article.reserved

                if (typeof val === 'string') {
                    val = val.replace(',', '.')
                }

                const parsed = parseFloat(val)

                article.reserved = isNaN(parsed) ? null : parsed
            }

            this.canReserveArticle(article);
        },


        getToolbar() {
            const tools = [];
            //const hasSearch = this.$refs.addRequiredProjectItemsGrid?.ej2Instances?.searchSettings?.key?.length > 0;
			 if (hasPermission('canEditArticles')) {
            tools.push(
                { text: "Dodaj artykuł", prefixIcon: 'e-add', id: 'articles_add' }
            );
			}
            tools.push(
                { text: "Resetuj filtry", prefixIcon: 'e-reset', id: 'reset_filters' },
                { text: "Lista artykułów", prefixIcon: 'e-table-of-content', id: 'articles_list' },
                { text: "Search", prefixIcon: 'e-search', id: "search", align: 'center' }
            );
            if (this.hasSearch) {
                tools.push({
                    text: "",
                    prefixIcon: "e-close",
                    id: "clear_search",
                    align: 'center'
                });
            }
            tools.push(
                { text: "Przywróć domyślny", prefixIcon: 'e-undo', id: "restore", align: 'right' },
                { text: "Odśwież", prefixIcon: 'e-refresh', id: "refresh", align: 'right' },
                "ColumnChooser"

            );

            return tools;
        },


        getEditSettings() {
            return {
                allowEditing: true,
                allowAdding: false,
                allowDeleting: false,
                showConfirmDialog: false,
                showDeleteConfirmDialog: false,
                mode: 'Batch',
                newRowPosition: 'Top',
            };
        },
        normalizeArticleForSelection(input) {
            // Może przyjść już „goły” artykuł (z grida) albo RPI (ma .article)
            const rpi = input?.article ? input : null;
            const src = rpi ? rpi.article : input;

            // KLONOWANIE:
            // nie przenosimy żadnych stanów magazynowych z RPI
            // zawsze startujemy z magazynu głównego i ilością 0
            let availableQty = 0;

            if (!rpi) {
                const ai = input?.available_items || null;

                availableQty = ai && ai.article_warehouse_id === 1
                    ? Number(ai.quantity || 0)
                    : Number(src?.stock_quantity || 0);
            }

            // dostawcy -> string + array (do tagów)
            let suppliersShort = '';

            if (typeof rpi?.suppliers_short_names === 'string' && rpi.suppliers_short_names.length) {
                suppliersShort = rpi.suppliers_short_names;
            } else if (Array.isArray(rpi?.suppliers) && rpi.suppliers.length) {
                suppliersShort = rpi.suppliers.map(s => s.short_name).filter(Boolean).join(', ');
            } else if (typeof src?.suppliers_short_names === 'string') {
                suppliersShort = src.suppliers_short_names;
            }

            const suppliersArray = suppliersShort
                ? suppliersShort.split(',').map(s => s.trim()).filter(Boolean)
                : [];

            // głęboka kopia src, żeby nie mutować oryginału
            const base = JSON.parse(JSON.stringify(src || {}));

            // ilość wymagana
            const quantity_required = rpi
                ? (rpi.quantity_required !== undefined ? Number(rpi.quantity_required) : null)
                : null;

            // rezerwacja liczona tylko z aktualnie dostępnego magazynu
            const reserved = Math.min(
                (quantity_required * this.liczba_maszyn),
                availableQty
            );

            // ilość do zamówienia
            const quantity_to_order = Math.max(
                0,
                (quantity_required * this.liczba_maszyn) - availableQty
            );

            return {
                // ID artykułu, nie ID zapotrzebowania
                id: base.id,

                catalog_number: base.catalog_number || '',
                model: base.model || '',
                description: base.description || '',

                producer: base.producer || null,

                article_unit: base.article_unit || (base.unit_id
                    ? { id: base.unit_id, name: '' }
                    : null),

                photos: base.photos || [],
                files: base.files || [],

                // zawsze magazyn główny
                warehouse_id: 1,

                available_items: {
                    article_warehouse_id: 1,
                    quantity: availableQty
                },

                suppliers_short_names: suppliersShort,
                suppliers_short_names_array: suppliersArray,
                original_suppliers_short_names_array: [...suppliersArray],

                quantity_required: quantity_required,
                reserved: reserved,
                quantity_to_order: quantity_to_order,

                comments: rpi ? (rpi.comments ?? '') : ''
            };
        },
        /*
        normalizeArticleForSelection(input) {
          // Może przyjść już „goły” artykuł (z grida) albo RPI (ma .article)
          const rpi = input?.article ? input : null;
          const src = rpi ? rpi.article : input; // źródło pól artykułu
          const ai = input?.available_items || null;
        
          // dostępność – wybieramy najlepsze źródło
          const availableItems = ai ? (ai.article_warehouse_id === 1 ? ai.quantity : null) : null;
          const qtyFromNotEmpty = Array.isArray(rpi?.not_empty_warehouses)
              ? rpi.not_empty_warehouses.reduce((s, w) => s + Number(w?.quantity || 0), 0)
              : 0;
          const qtyFromWarehouses =
              Number(rpi?.article_main_warehouse?.quantity || 0) +
              Number(rpi?.article_project_warehouse?.quantity || 0);
        
          const availableQty =
              availableItems || qtyFromNotEmpty || qtyFromWarehouses || Number(src?.stock_quantity || 0) || 0;
        
          // dostawcy -> string + array (do tagów)
          let suppliersShort = '';
          if (typeof rpi?.suppliers_short_names === 'string' && rpi.suppliers_short_names.length) {
            suppliersShort = rpi.suppliers_short_names;
          } else if (Array.isArray(rpi?.suppliers) && rpi.suppliers.length) {
            suppliersShort = rpi.suppliers.map(s => s.short_name).filter(Boolean).join(', ');
          } else if (typeof src?.suppliers_short_names === 'string') {
            suppliersShort = src.suppliers_short_names;
          }
        
          const suppliersArray = suppliersShort
              ? suppliersShort.split(',').map(s => s.trim()).filter(Boolean)
              : [];
        
          // głęboka kopia src, żeby nie mutować oryginału
          const base = JSON.parse(JSON.stringify(src || {}));
        
          // 🔹 ustawienia ilości wymaganej
          //const quantity_required = rpi ? (rpi.quantity_required ? Number(rpi.quantity_required) : 1) : 1;
        const quantity_required = rpi ? (rpi.quantity_required !== undefined ? Number(rpi.quantity_required) : null) : null;
          // 🔹 rezerwacja maksymalnie tyle, ile jest w magazynie
          const reserved = Math.min((quantity_required * this.liczba_maszyn), availableQty);
        
          // 🔹 reszta do zamówienia
          const quantity_to_order = Math.max(0, (quantity_required * this.liczba_maszyn) - availableQty);
        
          return {
            // kluczowe ID – używamy ID artykułu (nie RPI!)
            id: base.id,
        
            // pola wyświetlane w tabeli wybranych
            catalog_number: base.catalog_number || '',
            model: base.model || '',
            description: base.description || '',
            producer: base.producer || null,
            article_unit: base.article_unit || (base.unit_id ? {id: base.unit_id, name: ''} : null),
        
            // zdjęcia/pliki (opcjonalnie)
            photos: base.photos || [],
            files: base.files || [],
        
            // stan magazynowy w kształcie zgodnym z gridem
            available_items: {quantity: availableQty},
        
            // tagi dostawców
            suppliers_short_names: suppliersShort,
            suppliers_short_names_array: suppliersArray,
            original_suppliers_short_names_array: [...suppliersArray],
        
            // wartości edytowalne w modale
            quantity_required: quantity_required,
            reserved: reserved,
            quantity_to_order: quantity_to_order,
            comments: rpi ? (rpi.comments ?? '') : ''
          };
        
        */

        addManyToSelected(list) {
            if (!Array.isArray(list)) return;

            list.forEach(item => {
                this.addToNewItems(item);
            });
        },

        /*
        addManyToSelected(list) {
          if (!Array.isArray(list)) return;
        
          list.forEach(item => {
            const normalized = this.normalizeArticleForSelection(item);
        
            if (!normalized?.id) return;
            if (this.selectedArticles.some(a => a.id === normalized.id)) return;
        
            this.selectedArticles.push(normalized);
        
            this.fetchQuantityToOrder(normalized, this.project, this.team);
          });
        },
        */
        addToNewItems(rowData) {
            if (!this.selectedArticles.find(i => i.id === rowData.id)) {
                const article = this.normalizeArticleForSelection(rowData);
                this.selectedArticles.push(article);
                this.canReserveArticle(article);
                this.fetchQuantityToOrder(article, this.project, this.team)
            }
        },

        async fetchQuantityToOrder(article, projectId, team) {
            this.quantityToOrderIsLoading = true;

            try {
                const teamName = typeof team === 'string' ? team : team.name ?? team;

                const resp = await axios.get(route('article.getQuantityToOrder', {
                    article: article.id,
                    project: projectId,
                    team: teamName,
                }));

                // Zapisz wynik pod kluczem artykułu
                this.quantityToOrderMap[article.id] = resp.data.quantity_to_order;
            } catch (e) {
                console.error(e);
                this.quantityToOrderMap[article.id] = 'Błąd pobierania';
            } finally {
                this.quantityToOrderIsLoading = false;
            }
        },

        removeFromSelectedArticles(articleId) {
            this.selectedArticles = this.selectedArticles.filter(item => item.id !== articleId);
        },

        isArticleSelected(articleId) {
            return this.selectedArticles.some(item => item.id === articleId);
        },

        parseSuppliersString(suppliersString) {
            // Zamiana stringa "a, b, c" na ["a", "b", "c"]
            return suppliersString ? suppliersString.split(',').map(s => s.trim()) : [];
        },

        clickToolbarHandler: async function (args) {

            if (args.item.id === "clear_search") {
                const grid = this.$refs.addRequiredProjectItemsGrid.ej2Instances;

                grid.searchSettings.key = "";
                grid.query = new Query();      // usuwa predicate
                grid.search("");
                grid.refresh();

                this.hasSearch = false;
                this.values = "";
                this.toolbar = this.getToolbar();
            }

            if (args.item.id === 'articles_add' || args.item.text === 'Add') {
                args.cancel = true;
                this.$refs.addArticleModalRef.show();
                return;
            }

            if (args?.item.id === 'restore') {
                let grid = this.$refs.addRequiredProjectItemsGrid;
                let gridName = 'grid' + grid.$el.id;
                grid.ej2Instances.enablePersistence = false;
                window.localStorage.setItem(gridName, "");
                grid.ej2Instances.destroy();

                // usuń ?ids=... i/lub ids[]=... z aktualnego adresu
                (function stripIdsFromUrl() {
                    try {
                        const url = new URL(window.location.href);
                        url.searchParams.delete('ids');    // np. ?ids=1,2,3
                        url.searchParams.delete('ids[]');  // np. ?ids[]=1&ids[]=2
                        history.replaceState(history.state, '', url.toString());
                    } catch (e) {
                        // fallback dla bardzo starych przeglądarek
                        const href = window.location.href;
                        const cleaned = href
                            .replace(/([?&])ids(\[\])?=[^&#]*&?/g, '$1')
                            .replace(/[?&]$/, '');
                        history.replaceState(history.state, '', cleaned);
                    }
                })();

                location.reload();
            }

            if (args.item.id === 'reset_filters') {
                this.$refs.addRequiredProjectItemsGrid.clearFiltering();
            }

            /**
             * Akcja przy kliknięciu listy artykułów
             */
            if (args.item.id === 'articles_list') {
                window.open(route('articles.index'), '_blank');
            }

            /**
             * Akcja przy kliknięciu odświeżania tabeli
             */
            if (args.item.id === 'refresh') {
                this.$refs.addRequiredProjectItemsGrid.ej2Instances.refresh();
            }
        },

        async saveSelectedPositions() {
            // pokaż czy, aby na pewno tyle zareserwować? (jak pojawi się wykrzyknik)
            const differentReservedAndRequired = Object.values(this.selectedArticles).some(item => Number(item.reserved) != Number(item.quantity_required * this.liczba_maszyn));
            if (differentReservedAndRequired) {
                const result = await Toast.fire({
                    toast: false,
                    position: 'center',
                    icon: 'question',
                    title: 'Na pewno dodać?',
                    html: "W niektórych pozycjach wpisano inną ilość rezerwacji niż ilość wymagana, na pewno kontynuować dodawanie?",
                    showClass: { popup: 'animate__animated animate__fadeInDown' },
                    hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                    timer: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Tak',
                    confirmButtonColor: 'success',
                    showCancelButton: true,
                    cancelButtonText: 'Nie',
                });

                if (!result.isConfirmed) {
                    this.isSubmiting = false;
                    return;
                }
            }

            if (!this.allArticlesReservable) {
                this.errorMsg('Nie można dokonać rezerwacji przynajmniej jednego artykułu.');
                return;
            }

            this.isSubmiting = true;
            // sprawdź, czy któraś z zaznaczonych pozycji nie ma wpisanej lub jest 0 ilości wymaganej
            const hasZeroQuantity = Object.values(this.selectedArticles).some(item => !item.quantity_required);

            // info czy na pewno chcesz dodać bez wprowadzonej ilości wymaganej
            if (hasZeroQuantity) {
                const result = await Toast.fire({
                    toast: false,
                    position: 'center',
                    icon: 'question',
                    title: 'Brak ilości wymaganej',
                    html: "Niektóre pozycje mają brakującą lub zerową ilość wymaganą. Dodać mimo to?",
                    showClass: { popup: 'animate__animated animate__fadeInDown' },
                    hideClass: { popup: 'animate__animated animate__fadeOutUp' },
                    timer: false,
                    showConfirmButton: true,
                    confirmButtonText: 'Tak',
                    confirmButtonColor: 'success',
                    showCancelButton: true,
                    cancelButtonText: 'Nie',
                });

                if (!result.isConfirmed) {
                    this.isSubmiting = false;
                    return;
                }
            }

            this.saveArticles();
        },


        async getArticles() {
            this.articlesDataManager = new DataManager({
                url: route('articles.get', {
                    project: this.selectedProjectId,
                    team: this.selectedTeamName,
                    without_deleted: true
                }),
                adaptor: new WebMethodAdaptor(),
                batchUrl: route('requiredProjectItems.saveChanges'),
                updateUrl: route('requiredProjectItems.updateChanges'),
                crossDomain: true,
                headers: [
                    { 'X-CSRF-TOKEN': usePage().props.csrf_token }
                ],
            });
        },


        saveArticles() {
            if (!this.project) {
                this.$emit("added-error", 'Nie został wybrany projekt.');
                return;
            }

            if (!this.team) {
                this.$emit("added-error", 'Nie został wybrany zespół.');
                return;
            }

            if (Object.keys(this.selectedArticles).length === 0) {
                this.$emit("added-error", 'Nie został wybrany żaden artykuł');
                return;
            }

            // ogranicz wysyłanie danych tylko do tych potrzebnych.
			//quantity_required: (article.quantity_required * this.liczba_maszyn),
            const payload = this.selectedArticles.map(article => ({
                id: article.id,

			   quantity_required: article.quantity_required,
                comments: article.comments,
                suppliers_short_names: article.suppliers_short_names,
                reserved: article.reserved ?? 0
            }));

            this.$inertia.post(route("requiredProjectItems.addArticleToList", {
                project: this.project,
                team: this.team,
                articles: payload
            }), {}, {
                preserveState: true,
                onSuccess: () => {
                    this.$emit("added-article");
                    this.$emit("added-success", "Artykuły zostały poprawnie dodane do zapotrzebowania.");
                    this.selectedArticles = [];
                    this.$refs.addRequiredProjectItemsGrid.clearSelection();
                    this.hide();
                },
                onError: (resp) => {
                    console.error("Błąd zapisu:", resp);
                    this.$emit("added-error", Object.keys(resp)[0] ?? resp);
                },
                onFinish: () => {
                    this.isSubmiting = false;
                }
            });
        },

        changeSuppliersHandler(article, selectedItems) {
            if (!selectedItems || selectedItems.length === 0) {
                article.suppliers_short_names_array = [];
                article.suppliers_short_names = "";
            } else {
                // Aktualizujemy array
                article.suppliers_short_names_array = selectedItems;

                // Zamieniamy array na string z przecinkami
                article.suppliers_short_names = selectedItems.join(', ');
            }
        },

        preventDecimal(e, article) {
            // blokowanie wpisanie dziesiętnych jeśli article_unit to np. sztuki
            if (!article?.article_unit?.allow_decimal) {
                if (e.key === '.' || e.key === ',') {
                    e.preventDefault();
                }
            }
        },

        isOriginalSupplier(option, article) {
            return article.original_suppliers_short_names_array.includes(option.short_name);
        },

        actionBegin(args) {
            //
            // WYSZUKIWARKA- wyszukiwanie wielu wartości z separatorem (przecinek
            //
            if (args.requestType === 'searching') {
                const grid = this.$refs.addRequiredProjectItemsGrid.ej2Instances;
                const keys = args.searchString.split(';');
                let predicate;

                if (grid.searchSettings.key !== '') {
                    this.values = args.searchString;

                    keys.forEach((key) => {
                        const lowerKey = key.toLowerCase();

                        grid.getColumns().forEach((col) => {
                            let field = col.field;
                            let value = key;

                            if (field === 'producer_name') {
                                const match = this.copyproducers.find(p =>
                                    p.name.toLowerCase().includes(lowerKey)
                                );
                                if (match) {
                                    value = match.name;
                                } else {
                                    // nie znaleziono producenta - pomijamy tę kolumnę
                                    return;
                                }
                            }

                            const predic = new Predicate(field, 'contains', value, true);

                            if (!predicate) {
                                predicate = predic;
                            } else {
                                predicate = predicate.or(predic);
                            }
                        });
                    });

                    grid.query = new Query().where(predicate);

                } else {
                    grid.searchSettings.key = '';
                }

                this.refresh = true;
                this.valueAssign = true;
                this.removeQuery = true;
                grid.refresh();
            }
        },

        actionComplete(args) {
            if (args.requestType === "refresh" && this.valueAssign) {
                document.getElementById(
                    this.$refs.addRequiredProjectItemsGrid.ej2Instances.element.id + "_searchbar"
                ).value = this.values;
                this.valueAssign = false;
            } else if (
                document.getElementById(
                    this.$refs.addRequiredProjectItemsGrid.ej2Instances.element.id + "_searchbar"
                ).value === "" &&
                args.requestType === "refresh" &&
                this.removeQuery
            ) {
                this.$refs.addRequiredProjectItemsGrid.ej2Instances.query = new Query();
                this.removeQuery = false;
                this.$refs.addRequiredProjectItemsGrid.ej2Instances.refresh();
            }
            if (args.requestType === "searching") {
                this.hasSearch = !!args.searchString;
                this.toolbar = this.getToolbar();
            }
        },

        async canReserveArticle(article) {

            // Dodajemy artykułu do zarezerwowanych
            this.reservingArticles[article.id] = { ok: false };

            try {
                const response = await axios.get(route('warehouse.check-article-reservation', {
                    article: article.id,
                    reserving: article.reserved
                }));

                const { canReserve, currentlyReserved, quantityLeftToReserve } = response.data;
                this.reservingArticles[article.id].currently_reserved = currentlyReserved;

                // przypisz od razu maksymalną wartość do rezerwowania jeśli nie była już wpisana
                if (article.reserved === null || article.reserved === undefined)
                    article.reserved = Math.max(quantityLeftToReserve ?? 0, 0);


                // zablokuj ewentualne dodawanie artykułu jeśli user chce zarezerwować więcej niż może.
                if (parseFloat(article.reserved) === 0) {
                    // Jeśli user wpisze rejestrację 0 – to traktuj jako OK
                    this.reservingArticles[article.id].ok = true;
                } else if (canReserve) {
                    this.reservingArticles[article.id].ok = true;
                } else {
                    this.reservingArticles[article.id].ok = false;
                    this.errorMsg(`Nie można zarezerwować tej ilości. Max: ${Math.max(quantityLeftToReserve ?? 0, 0)}`);
                }
            } catch (error) {
                this.errorMsg('Nie można sprawdzić rezerwacji:' + error.message);
                this.reservingArticles[article.id].ok = false;
                console.log(error);
            }
        },

        show() {
            if (this.modalObj) {
                this.modalObj.show();
            }
        },
        hide() {
            if (this.modalObj) {
                this.modalObj.hide();
            }
        },

    }
}

</script>

<style scoped>
.tag-item {
    display: inline-flex;
    align-items: center;
    padding: 0.15em 0.5em;
    margin: 0.15em;
    border-radius: 0.25em;
}

.original-tag {
    background-color: #e0e0e0;
    color: #000;
}

.new-tag {
    background-color: orange;
    color: #fff;
}

.tag-item button {
    background: none;
    border: none;
    color: inherit;
    cursor: pointer;
    margin-left: 0.5em;
}

.modal-parent-inactive .modal-content {
    opacity: 0.5;
    filter: blur(2px);
    transition: all .2s ease;
    pointer-events: none;
}
</style>